export default __webpack_public_path__ + "static/media/EnrolledPatientReport.dc53a313.svg";